module.exports = __webpack_public_path__ + "img/szjc7.ba048561.png";